import { apiPost } from "./CustomerApi";


export async function onboardStaff(data) {
    const path = '/api/user/onboard-staff';

    return apiPost(path, data)
        .then((data) => {return data;})

}

export async function offboardStaff(data) {
    const path = '/api/user/offboard-staff';

    return apiPost(path, data)
        .then((data) => {return data;})

}